// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "initial-39U94";
var _3 = "wrapper-2vavl";
var _4 = "searchForm__title-2zHxu";
export { _1 as "__esModule", _2 as "initial", _3 as "wrapper", _4 as "searchForm__title" }
export default { "__esModule": _1, "initial": _2, "wrapper": _3, "searchForm__title": _4 }
